var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.enabled)?_c('b-card',{attrs:{"header":"Debug Console","header-bg-variant":"dark","header-class":"header","body-text-variant":"dark","body-class":"body"}},[_c('textarea',{staticClass:"debug-messages",attrs:{"readonly":""},domProps:{"value":_vm.messages}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }